import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ceee7a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "after-rule" }
const _hoisted_2 = { class: "after-rule-box" }
const _hoisted_3 = ["innerHTML"]

import { ref, inject } from 'vue'
import Header from "@/components/header/header.vue";
import { Toast } from 'vant';

export default /*#__PURE__*/_defineComponent({
  __name: 'afterSaleRule',
  setup(__props) {

const $http: any = inject('$http')
let ruleData = ref('')
const getRuleData = async () => {
    const res: any = await $http.getAfterSaleRule()
    if (res.code === 200) {
        ruleData.value = res.data
    } else {
        Toast(res.msg)
    }
}
getRuleData()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Header, {
      title: "Rules",
      backgroundColor: "#FFFFFF",
      fontColor: "#303133",
      ios_app: true
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "after-rule-content",
        innerHTML: _unref(ruleData)
      }, null, 8, _hoisted_3)
    ])
  ]))
}
}

})